export default {
  getConfigHeader: state => state.header,
  getConfigFooter: state => state.footer,
  getConfigSidebar: state => state.sidebar,
  getConfigMenu: state => state.menu,
  getConfigLayout: state => state.config,
  getConfigDefaultPage: state => state.defaultPage,
  getConfigLogin: state => state.login,
  getConfigTheme: state => state.theme,
  getBreadcrumbs: state => state.breadcrumbs,
  getDialogs: state => dialog => state.dialogs[dialog],
  getConfigLoading: state => state.loading,
  getConfigPaths: state => state.paths,
  getConfigExpiredMessage: state => state.expiredMessage,
  getConfigForm: state => state.form,
  getConfigDefaultActions: state => state.defaultActions,
  getConfigEnvironmentDefaults: state => state.environmentDefaults
};
